var _circle, _rect, _path, _path2, _path3, _rect2, _path4, _path5, _path6, _rect3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect4, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 60,
    stroke: "#CFD3D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "20 20"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 10.5H25.5C24.672 10.5 24 11.172 24 12C24 12.828 24.672 13.5 25.5 13.5H42.129L32.913 20.667L26.304 16.464L24.696 18.996L32.196 23.766C32.439 23.922 32.721 24 33 24C33.324 24 33.651 23.895 33.921 23.685L45 15.066V34.5H25.5C24.672 34.5 24 35.172 24 36C24 36.828 24.672 37.5 25.5 37.5H46.5C47.328 37.5 48 36.828 48 36V12C48 11.172 47.328 10.5 46.5 10.5Z",
    fill: "#64B5F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.457 1.84312C26.115 1.55812 25.656 1.43512 25.224 1.52512L1.224 6.02512C0.513 6.15712 0 6.77512 0 7.49812V40.4981C0 41.2181 0.513 41.8391 1.224 41.9711L25.224 46.4711C25.314 46.4891 25.407 46.4981 25.5 46.4981C25.848 46.4981 26.187 46.3781 26.457 46.1531C26.802 45.8681 27 45.4421 27 44.9981V2.99812C27 2.55112 26.802 2.12812 26.457 1.84312Z",
    fill: "#2196F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 34.5C9.366 34.5 6 30.462 6 25.5C6 20.538 9.366 16.5 13.5 16.5C17.634 16.5 21 20.538 21 25.5C21 30.462 17.634 34.5 13.5 34.5ZM13.5 19.5C11.019 19.5 9 22.191 9 25.5C9 28.809 11.019 31.5 13.5 31.5C15.981 31.5 18 28.809 18 25.5C18 22.191 15.981 19.5 13.5 19.5Z",
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(96)",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138 6H102V42H138V6Z",
    fill: "#ECEFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120 27.7855L138 41.9995V13.9375L120 27.7855Z",
    fill: "#CFD8DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 6H138L120 20.214L102 6H100.5C98.016 6 96 8.016 96 10.5V37.5C96 39.984 98.016 42 100.5 42H102V13.938L120 27.783L138 13.935V42H139.5C141.984 42 144 39.984 144 37.5V10.5C144 8.016 141.984 6 139.5 6Z",
    fill: "#F44336"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(96 96)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.332 105.336H121.332V134.669H141.332C142.805 134.669 143.999 133.476 143.999 132.003V108.003C143.999 106.529 142.805 105.336 141.332 105.336Z",
    fill: "#64B5F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140 112.324V115.58C140 115.767 140 116.084 139.814 116.247L137.387 118.673C137.198 118.86 137.011 118.86 136.823 118.673L135.896 117.923C135.703 117.736 135.703 117.549 135.896 117.365L137.011 116.245V112.325H133.651C130.667 114.564 128.24 118.672 127.491 117.923C126.563 117.179 132.35 109.523 133.088 109.34H139.438C139.812 109.34 140 109.527 140 109.897V112.324Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.017 130.666H133.755C133.569 130.666 133.255 130.666 133.094 130.479L130.667 128.052C130.481 127.863 130.481 127.676 130.667 127.488L131.413 126.556C131.599 126.37 131.786 126.37 131.974 126.556L133.094 127.676H137.017V124.316C134.771 121.332 130.667 118.906 131.413 118.156C132.162 117.223 139.813 123.015 140.001 123.754V130.103C140.001 130.478 139.814 130.666 139.438 130.666H137.017Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.391 127.681V124.419C119.391 124.233 119.391 123.919 119.577 123.758L122.004 121.331C122.193 121.145 122.38 121.145 122.568 121.331L123.495 122.077C123.688 122.263 123.688 122.45 123.495 122.638L122.38 123.758V127.681H125.74C128.724 125.435 131.151 121.331 131.9 122.077C132.828 122.826 127.041 130.477 126.303 130.665H119.953C119.579 130.665 119.391 130.478 119.391 130.102V127.681Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.375 109.34H125.636C125.823 109.34 126.136 109.34 126.297 109.527L128.724 111.953C128.911 112.141 128.911 112.324 128.724 112.512L127.973 113.449C127.792 113.636 127.604 113.636 127.416 113.449L126.296 112.324H122.376V115.689C124.615 118.673 128.724 121.1 127.973 121.845C127.229 122.783 119.579 116.992 119.391 116.245V109.903C119.391 109.528 119.577 109.34 119.953 109.34H122.375Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124 142.792C124 143.419 123.429 143.891 122.813 143.774L97.2193 138.899C96.5119 138.764 96 138.146 96 137.425V102.575C96 101.854 96.5119 101.236 97.2193 101.101L122.813 96.2261C123.429 96.1087 124 96.5811 124 97.2085V142.792Z",
    fill: "#1E88E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.667 131.753L104 130.819V110.415L114.292 109.301V113.41L107.932 113.79V118.473L113.735 118.285V122.394H107.932V127.269L114.667 127.639V131.753Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(0 96)",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9941 117.354C40.998 117.237 41 117.119 41 117C41 109.832 35.168 104 28 104C23.2676 104 18.9199 106.595 16.6406 110.694C15.6582 110.238 14.5898 110 13.5 110C9.62891 110 6.43164 112.949 6.05078 116.852C2.40625 118.423 0 122.02 0 126C0 131.514 4.48633 136 10 136H38.5C43.7383 136 48 131.738 48 126.5C48 122.177 45.1035 118.464 40.9941 117.354Z",
    fill: "url(#le0_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9941 117.354C40.998 117.237 41 117.119 41 117C41 109.832 35.168 104 28 104C23.2676 104 18.9199 106.595 16.6406 110.694C15.6582 110.238 14.5898 110 13.5 110C9.62891 110 6.43164 112.949 6.05078 116.852C2.40625 118.423 0 122.02 0 126C0 131.514 4.48633 136 10 136H38.5C43.7383 136 48 131.738 48 126.5C48 122.177 45.1035 118.464 40.9941 117.354Z",
    fill: "url(#paint1_radial)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 136C43.7467 136 48 131.747 48 126.5C48 121.253 43.7467 117 38.5 117C33.2533 117 29 121.253 29 126.5C29 131.747 33.2533 136 38.5 136Z",
    fill: "url(#le2_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10 136C15.5228 136 20 131.523 20 126C20 120.477 15.5228 116 10 116C4.47715 116 0 120.477 0 126C0 131.523 4.47715 136 10 136Z",
    fill: "url(#le3_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.5 125C17.6421 125 21 121.642 21 117.5C21 113.358 17.6421 110 13.5 110C9.35786 110 6 113.358 6 117.5C6 121.642 9.35786 125 13.5 125Z",
    fill: "#56C7DA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28 130C35.1797 130 41 124.18 41 117C41 109.82 35.1797 104 28 104C20.8203 104 15 109.82 15 117C15 124.18 20.8203 130 28 130Z",
    fill: "url(#le4_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9941 117.354C40.998 117.237 41 117.119 41 117C41 109.832 35.168 104 28 104C23.2676 104 18.9199 106.595 16.6406 110.694C15.6582 110.238 14.5898 110 13.5 110C9.62891 110 6.43164 112.949 6.05078 116.852C2.40625 118.423 0 122.02 0 126C0 131.514 4.48633 136 10 136H38.5C43.7383 136 48 131.738 48 126.5C48 122.177 45.1035 118.464 40.9941 117.354Z",
    fill: "url(#le5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "le0_linear",
    x1: 0,
    y1: 120,
    x2: 48,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95DCF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#507EFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6667 135.5) scale(20.3961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009ADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E88E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "le2_linear",
    x1: 29.888,
    y1: 122.484,
    x2: 47.112,
    y2: 130.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "le3_linear",
    x1: 17.187,
    y1: 121.126,
    x2: 2.68701,
    y2: 130.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "le4_linear",
    x1: 28,
    y1: 104,
    x2: 28,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACCD",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127444,
    stopColor: "#1AB4D2",
    stopOpacity: 0.174511
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400106,
    stopColor: "#5CCADF",
    stopOpacity: 0.119979
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79292,
    stopColor: "#C5ECF4",
    stopOpacity: 0.041416
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "le5_linear",
    x1: 4.91407,
    y1: 113.277,
    x2: 46.1756,
    y2: 132.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.a138dfd9.svg";
export { ForwardRef as ReactComponent };